/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFeed} from '../api'

 export const useQueryGetFeed = createReactQueryHook('getFeed', getFeed)
